import { DOG_EAR, dogEarFlap, dogEarOutline } from "../../shared/notes";

/** The id of the board's one hidden "Opens the note" (shared/notes.ts NOTE_SLIP_HINT), the closed slips' description. */
export const SLIP_HINT_ID = "slip-opens-hint";

const size = DOG_EAR.size;
const flap = dogEarFlap(size);
/** The paper with its corner gone past the crease (shared/notes.ts dogEarOutline), as a clip-path. */
const clip = `polygon(0 0, 100% 0, ${dogEarOutline(size)
  .map(([x, y]) => `calc(100% - ${x}px) calc(100% - ${y}px)`)
  .join(", ")}, 0 100%)`;

/**
 * A closed slip's paper with the dog-ear (shared/notes.ts DOG_EAR; owner, 2026-10-20: "There needs to
 * be some indication that notes can be expanded visually"): drawn behind the slip's contents in
 * place of `.slip`'s own face, the parchment and its ink edge clipped at the crease, the flap of the
 * paper's underside in the corner, and the slip's 2px step shadow following the cut.
 */
export function DogEarSheet() {
  return (
    <span class="slip-sheet" aria-hidden="true">
      <span class="slip-sheet-paper" style={{ clipPath: clip }} />
      <svg class="slip-ear" width={size} height={size} viewBox={`0 0 ${size} ${size}`} shape-rendering="crispEdges" focusable="false">
        {flap.underside.map(([x, y, w, h]) => (
          <rect key={`u${x}-${y}`} x={x} y={y} width={w} height={h} fill={DOG_EAR.underside} />
        ))}
        {flap.ink.map(([x, y, w, h]) => (
          <rect key={`i${x}-${y}`} x={x} y={y} width={w} height={h} fill="#4a2c12" />
        ))}
      </svg>
    </span>
  );
}
